var _polygon, _circle, _path, _circle2, _rect, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "valuesGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#5F7A61"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#F5F0E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#E5DECF"
    }
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "32,4 52,16 52,48 32,60 12,48 12,16",
    fill: "url(#valuesGradient)",
    opacity: 0.8
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 18,
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    opacity: 0.6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 24 24 L 28 20 L 32 24 L 36 20 L 40 24 L 36 28 L 32 32 L 28 28 Z",
    fill: "#FFFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 18,
    r: 3,
    fill: "#1C1917"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 28,
    width: 6,
    height: 8,
    fill: "#1C1917",
    rx: 1
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 46,
    r: 3,
    fill: "#1C1917"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 46,
    r: 2,
    fill: "#1C1917"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 46,
    r: 2,
    fill: "#1C1917"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 32,
    r: 3,
    fill: "#1C1917"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 30,
    r: 1.5,
    fill: "#1C1917"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 34,
    r: 1.5,
    fill: "#1C1917"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuesIcon);
export default __webpack_public_path__ + "static/media/values-icon.241453ef61ac90f69addc2bc09d3c080.svg";
export { ForwardRef as ReactComponent };